var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-4 d-flex flex-column align-center"},[_c('span',{staticClass:"title"},[_vm._v("Wir richten die "+_vm._s(_vm.readablePlatformName)+"-App jetzt für Sie persönlich ein.")]),_c('v-progress-circular',{staticClass:"mt-4",attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }